var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isVisibleCondition)?_c('LmConditionalBuilderUi',{staticClass:"col-12",attrs:{"visibilityDependOnConditions":_vm.visibilityDependOnConditions,"self":_vm.component.formObjectToSendToServerProperty}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }